import { combineReducers } from "redux";
import authentication from "../../modules/authentication/services";
import sidebar from "../../shared/components/sidebar/services";
import service_types from "../../modules/serviceTypes/services";
import shampoo_state from "../../modules/shampooSelections/services";
import cologne_state from "../../modules/cologneSelections/services";
import pet_sizes from "../../modules/setGeneralPetSizes/services";
import appointment from "../../modules/appointment/services";
import add_on_services from "../../modules/addOnServices/services";
import feeding_info_state from "../../modules/feedingInformation/services";
import extended_behavior from "../../modules/extendedBehaviorInformation/services";
import services from "../../modules/myServices/services";
import attendants from "../../modules/attendant/services";
import pet_types from "../../modules/petType/services";
import venue_list from "../../modules/venueList/services";
import pet_types_list from "../../modules/venues/services";
import schedule from "../../modules/schedule/services";
import customer_pets from "../../modules/customerPet/services";
import service_history_details from "../../modules/customerServiceHistory/services";
import service_history_notes from "../../modules/customerServiceHistory/services";
import service_history_notes_list from "../../modules/customerServiceHistory/services";
import service_history_notes_by_pet_id_list from "../../modules/customerServiceHistory/services";
import add_service_history_notes_list from "../../modules/customerServiceHistory/services";
import service_history from "../../modules/customerServiceHistory/services";
import venues from "../../modules/venues/services";
import time_zone_list from "../../shared/components/header/services";
import set_time_zone from "../../shared/components/header/services";
import search_customer_list from "../../modules/appointment/services";
import customer_address_list from "../../modules/appointment/services";
import appointments from "../../modules/Appointments/services";
import config_docs from "../../modules/documents/services";
import waiver_of_liability_configuration_info_state from "../../modules/waiverOfLiabilityConfiguration/services";
const rootReducer = combineReducers({
  authentication,
  sidebar,
  service_types,
  attendants,
  shampoo_state,
  cologne_state,
  feeding_info_state,
  pet_sizes,
  appointment,
  add_on_services,
  extended_behavior,
  services,
  pet_types,
  venue_list,
  pet_types_list,
  schedule,
  appointments,
  customer_pets,
  service_history_details,
  service_history_notes,
  service_history_notes_list,
  service_history_notes_by_pet_id_list,
  add_service_history_notes_list,
  service_history,
  venues,
  time_zone_list,
  set_time_zone,
  search_customer_list,
  customer_address_list,
  config_docs,
  waiver_of_liability_configuration_info_state,
});

export default rootReducer;
